import useSWR from 'swr';
import { config } from '@/config';
import { identityVerificationService } from '@/services/api';
import { AwaitedReturnType, FetchErrorsType } from '@/types';

const API_URL = config.api.url.verification;

export const useIdentityVerificationStatus = (requestToken: string, pollingDuration = 0) =>
    useSWR<AwaitedReturnType<typeof identityVerificationService.getStatus>, FetchErrorsType>(
        `${API_URL}/${requestToken}/identity`,
        () => identityVerificationService.getStatus(requestToken),
        { shouldRetryOnError: false, revalidateOnFocus: false, refreshInterval: pollingDuration },
    );
